import React, {useEffect, useRef, useState} from 'react';
import UModal from "ubs-framework/v2/UModal/NewUModal";
import UButton from "ubs-framework/v2/UButton";
import {useLocation} from "react-router-dom";
import {useForceUpdate} from "ubs-framework/v2/hooks/useForceUpdate";
import Validator from "simple-react-validator";
import {useDispatch, useSelector} from "react-redux";
import useSocket from "../../../../../common/hooks/useSocket";
import {errorFocus} from "ubs-framework/v2/common/function";
import {sendData} from "../../../../../../store/actions";
import UInput from "ubs-framework/v2/UInput";
import AsyncEmployeeSelect from "../../../../../common/employee-access-select/async-employee-select";
import Select from "react-select";
import {getKeyName} from "ubs-framework/v2/common/function";
import {QUESTIONS_TEMPLATE_TYPE} from "../../../../../../common/constant";
import {dayPipe, showToastSuccess} from "ubs-framework/v2/common/function";
import UEmployeeInfo from "../../../../../../common/components/UEmployeeInfo";
import MembersFullNameList from "../../../../../common/list/member-full-name-list";
import UNoDataFound from 'ubs-framework/v2/UErrorPages/UNoDataFound';

const AddEvaluation = React.memo((props) => {
    const DISPATCH = useDispatch();
    const location = useLocation();
    const forceUpdate = useForceUpdate();
    const validator = useRef(new Validator({element: (message) => <>{message}</>, autoForceUpdate: {forceUpdate}}));

    const _ID = useSelector(e => e?.common?._id);
    const _AEM = useSelector(e => e?.candidate?.addEvaluationModal || {});
    const _USERS = useSelector(e => e?.ats?.userObj || {});

    const [activeTab, setActiveTab] = useState('requested'); // requested / add / raise-request

    const [loader, setLoader] = useState(false);
    const [screeningQuestionsList, setScreeningQuestionsList] = useState([]);
    const [evaluationList, setEvaluationList] = useState([]);
    const [allValues, setAllValues] = useState({})

    const {on, off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'ats|setting|question-template|list':
                    if (res?.data?.questionTemplateList?.length) {
                        let list = JSON.parse(JSON.stringify(res?.data?.questionTemplateList));
                        list = list?.filter(e => e?.questions?.length)?.map(l => ({...l, label: l?.name, value: l?._id}));
                        setScreeningQuestionsList(list);
                    }
                    break
                case 'ats|candidate-evaluation|request':
                    handle.close()
                    setLoader(false);
                    break;
                case 'ats|candidate-evaluation|requestList': {
                    const requestList = res?.data?.requestList.filter(e => e.to.includes(_ID)) || [];

                    if(requestList?.length > 0) {
                        const findUser = new Set();
                        requestList?.forEach(e => {
                            if (e?.to?.length) e?.to?.map((stage, j) => {
                                findUser.add(stage);
                            })
                        })
                        if (findUser.size !== 0) DISPATCH({type: 'FIND_MASTER_DATA_LIST', payload: {findUserIdsList: [...findUser]}});
                        setEvaluationList(requestList)
                    } else {
                        setActiveTab('add')
                    }
                    break
                }
                default:
                    return true;
            }
        } else {
            switch (res.event) {
                case 'ats|candidate-evaluation|request':
                    setLoader(false);
                    break
                default:
                    return true;
            }
        }
    });
    useEffect(() => {
        refresh()
        sendData('ats|setting|question-template|list', {type: QUESTIONS_TEMPLATE_TYPE.EVALUATION_FORM});
        sendData('ats|candidate-evaluation|requestList', {candidate: _AEM?.data?.candidateId ? _AEM?.data?.candidateId : location.pathname.split('/')[4]})
        return () => off()
    }, [])

    const handle = {
        addCandidate: e => {
            if (activeTab === 'add') handle.clear('to')
            if (validator?.current?.allValid()) {
                let data = {
                    candidate: _AEM?.data?.candidateId ? _AEM?.data?.candidateId : location.pathname.split('/')[4],
                    evaluationForm: allValues?.evaluationForm?._id ?? '',
                    interviewId: _AEM?.data?.interviewId,
                    isInterview: _AEM?.data?.isInterview || false,
                    evaluationType: 1,
                }
                if (allValues?.to?.length) data.to = allValues?.to?.map(_ => _.value)
                if (activeTab === 'add') data.to = [_ID];
                if (activeTab === 'add') data.isGiveEvaluation = true;
                setLoader(true);
                sendData('ats|candidate-evaluation|request', data);
            } else {
                validator?.current?.showMessages();
                setLoader(false)
                errorFocus();
            }
        },
        close: e => {
            DISPATCH({type: 'ADD_EVALUATION_MODAL', payload: {flag: false, data: {}}});
        },
        change: (value, name) => {
            setAllValues({...allValues, [name]: value})
        },
        clear: (name) => {
            validator.current.hideMessageFor(name)
            validator.current.errorMessages[name] = undefined
            delete validator.current.errorMessages[name]
            validator.current.fields[name] = true
        },
        giveEvaluation: (data) => {
            DISPATCH({type: 'GIVE_EVALUATION_MODAL', payload: data})
            handle.close()
        }
    }

    return (
        <React.Fragment>
            <UModal
                open={true}
                maxWidth={600}
                header={<h4>{_AEM?.data?._id ? 'Edit' : 'Add'} Evaluation</h4>}
                onClose={() => handle.close()}
            >
                <div className="u_tabs u_border-bottom">
                    <ul className="u_flex u_align-center">
                        {evaluationList?.length > 0 && <li className={activeTab === 'requested' ? 'active' : ''} onClick={() => setActiveTab('requested')}><a>Requested</a></li>}
                        <li className={activeTab === 'add' ? 'active' : ''} onClick={() => setActiveTab('add')}><a>Add New</a></li>
                        <li className={activeTab === 'raise-request' ? 'active' : ''} onClick={() => setActiveTab('raise-request')}><a>Raise Request</a></li>
                    </ul>
                </div>

                <div className="u_p-20">
                    <div className="u_row">
                        {(evaluationList?.length > 0 && activeTab === 'requested') ? <React.Fragment>
                                {evaluationList?.length ? evaluationList?.map((data, i) => {
                                    return <div className="u_col-12 u_mb-10" key={i}>
                                        <div className="u_flex u_align-center u_b-light u_border-radius-5 u_py-8 u_px-10">
                                            <div className="u_flex u_align-center u_flex-1">
                                                <div className="u_mr-15 u_pr-15">
                                                    <p className="u_small-font u_mb-5 u_color-title">Requested By</p>
                                                    <UEmployeeInfo
                                                        size={24}
                                                        employee={_USERS[data?.createdBy]}
                                                        isSkeleton={!_USERS[data?.createdBy]}
                                                    />
                                                </div>
                                                <div className="u_mr-15 u_pr-15">
                                                    <p className="u_small-font u_mb-5 u_color-title">Evaluation Form</p>
                                                    <p className="u_small-font">{data?.name || ''}</p>
                                                </div>
                                            </div>

                                            <div className="u_flex u_align-center">
                                                <p className={`u_small-font u_color-title u_mr-15`}>{dayPipe(data?.createdAt)}</p>
                                                {data?.to?.includes(_ID) && <button style={{width: '100px'}} type="button" className={`u_btn u_btn__blue u_btn__smallBtn  large`} onClick={() => handle.giveEvaluation(data)}>Start</button>}
                                            </div>
                                        </div>
                                    </div>
                                }) : <UNoDataFound width={300} image="/images/no-data-found.svg" message="No data to display"/>}
                            </React.Fragment> :
                         <React.Fragment>
                             <div className="u_col-12 u_mb-15">
                                 <UInput label="Evaluation form" asterisk select selectValue={allValues?.evaluationForm}
                                         hasError={validator.current.message('evaluationForm', allValues?.evaluationForm, 'required')}>
                                     <Select
                                         name="evaluationForm"
                                         className="u_input-select-inner"
                                         classNamePrefix="u_select"
                                         isClearable={true}
                                         placeholder={' '}
                                         value={getKeyName(screeningQuestionsList, allValues?.evaluationForm)}
                                         onChange={e => handle.change(e, 'evaluationForm')}
                                         options={screeningQuestionsList}
                                         noOptionsMessage={() => 'No Evaluation form found'}
                                         maxMenuHeight={150}
                                         menuPosition={'fixed'}
                                         onKeyDown={e => {
                                             if ((e.keyCode === 32 || e.keyCode === 8 || e.keyCode === 9) && !e.target.value) e.preventDefault();
                                         }}
                                     />
                                 </UInput>
                             </div>

                             {activeTab === 'raise-request' && <div className="u_col-12">
                                 <UInput label="Request from" select asterisk selectValue={allValues?.to}
                                         hasError={validator.current.message('to', allValues?.to, 'required')}>
                                     <AsyncEmployeeSelect
                                         value={allValues?.to}
                                         onChange={(e) => handle.change(e, 'to')}
                                         params={{isMulti: true, menuPlacement: 'auto'}}
                                     />
                                 </UInput>
                             </div>}
                         </React.Fragment>
                        }
                    </div>
                </div>

                <div className="u_modal-buttons">
                    <UButton disabled={loader} loading={loader} variant="white" type="Cancel" onClick={(e) => handle.close()}/>
                    {activeTab !== 'requested' && <UButton disabled={loader} loading={loader} isSubmit variant="blue" type={activeTab === 'add' ? 'Give Evaluation' : 'Save'} cn="u_ml-10" onClick={handle.addCandidate}/>}
                </div>
            </UModal>
        </React.Fragment>
    );
});

export default AddEvaluation;
